export default __webpack_public_path__ + "static/media/IMG_2196.251e25d4.jpg";